import { CITY_ID, EVENT_PRICES, IS_USER_LOGIN, TOKEN } from "../action/CommonAction";
import { ActionInterface, isUserLogin, TicketRow } from "../model/CommonResponse";
// import { string } from "prop-types";

export interface tokenState {
  data: string;
}

export const userLoginFlag = (state: isUserLogin = { isUserLogin: typeof window !== "undefined" && Boolean(localStorage.getItem("token")) },
  action: ActionInterface) => {
  switch (action.type) {
    case IS_USER_LOGIN:
      return { isUserLogin: action.payload };
    default:
      return state;
  }
};

export const getToken = (state: tokenState = { data: "" }, action: ActionInterface) => {
  switch (action.type) {
    case TOKEN:
      return action.payload;
    default:
      return state;
  }
};

export const getCity = (state: string = typeof window !== "undefined" ? localStorage.getItem("city_id") ?? "" : "", action: ActionInterface) => {
  switch (action.type) {
    case CITY_ID:
      return action.payload;
    default:
      return state;
  }
};

export const getEventPrices = (state: TicketRow[] = [], action: ActionInterface) => {
  switch (action.type) {
    case EVENT_PRICES:
      return action.payload;
    default:
      return state;
  }
};
